export default __webpack_public_path__ + "static/media/twitter.ffc0ca7e.svg";